export const cleanSigunguWord = (sigunguName: string) => {
  return sigunguName.length > 2 ? sigunguName.slice(0, -1) : sigunguName;
};
